export const SET_TYPE ='SET_TYPE';
export const SET_AUTHOR_NAME = 'SET_AUTHOR_NAME';
export const SET_AUTHOR_LINK = 'SET_AUTHOR_LINK';
export const SET_SHOW_AUTHOR = 'SET_SHOW_AUTHOR';
export const SET_SHOW_TOC = 'SET_SHOW_TOC';
export const SET_SHOW_DATE = 'SET_SHOW_DATE';
